(function ($) {
  $(document).ready(function() {
    $('.block__hkbis-gallery__modal.modal').on('shown.bs.modal', function (e) {
      $(this).find('.slider').slick('setPosition');
    })

    $('.block__hkbis-gallery__image').click(function () {
      let image = $(this);
      let index = image.data('index');
      let block = image.closest('.block__hkbis-gallery');
      let slider = block.find('.slider');
      slider.slick('slickGoTo', index);
    });
  });
})(jQuery);
